import { Component, OnInit, Output, Input, EventEmitter, HostListener, ElementRef, SimpleChanges, ChangeDetectionStrategy, ViewChild, AfterViewInit, OnDestroy, OnChanges, ChangeDetectorRef,forwardRef  } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { SearchPipe } from '../../pipes/search.pipe';
import { fromEvent, Observable, Subscription } from 'rxjs';
import * as _ from 'lodash';
import { 
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS,
    Validator, 
    AbstractControl, 
    UntypedFormControl,
    ControlValueAccessor
  }
 from '@angular/forms';
import { get } from 'https';

@Component({
    selector: 'app-new-dropdown',
    templateUrl: './new-dropdown.component.html',
    styleUrls: ['./new-dropdown.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => NewDropdownComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => NewDropdownComponent),
            multi: true,
        }
    ]
    // changeDetection:ChangeDetectionStrategy.OnPush,
    ,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewDropdownComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges, ControlValueAccessor{
	@ViewChild('theInput', { static: false }) theInput: ElementRef;
	@Input() appModel: any;
	@Input() list: any = [];
	@Input() valueId: string;
	@Input() useTrackBy: boolean = false;
	@Input() nameLabel: string;
	@Input() placeholder: string;
	@Input() required: boolean;
	@Input() backTranslate: boolean;
	@Input() toCreate: boolean;
	@Input() multiple: boolean;
	@Input() debug: boolean;
	@Input() showEmpty: boolean;
	@Input() color: boolean;
	@Input() disabled: boolean;
  

	@Input() createValue: string;
	@Input() uppercase: boolean;
	@Input() keepOpen: boolean = true;
	@Input() showCheckboxOptions: boolean = false;

	@Output() appModelChange = new EventEmitter<string>();
	@Output() createValueChange = new EventEmitter<string>();
	@Output() appChange = new EventEmitter<string>();
	@Output() onClose = new EventEmitter<string>();

  onChange: any = () => {};
  onTouched: any = () => {};
  

	filteredList: any = [];
	inputValue: string;
	searchvalue: string;

	showOptions: boolean = false;
	wasInside: boolean = false;
	itemWasSelected: boolean = false;
	firstOpen: boolean = false;
	wasClickNav: boolean = false;

	sliceStart: number = 0
	sliceLength: number = 25
	sliceEnd: number = this.sliceLength
	selected_color: any = [];

	$documentClick: Observable<Event>;
	$inputClick: Observable<Event>;
	subs: Subscription[] = [];

  value: any;

  


	clickEmpty() {
		this.appModel = undefined
		this.appModelChange.emit(this.appModel);
    this.setValueControl(this.appModel)
	}

	moveSlice(ev, element) {
		this.wasClickNav = true;
		element.scrollTop = 0;

		if (ev == 'next') {
			this.sliceStart += this.sliceLength;
			this.sliceEnd += this.sliceLength;
		} else {
			this.sliceStart -= this.sliceLength;
			this.sliceEnd -= this.sliceLength;
		}
		if (this.keepOpen) {
			setTimeout(() => {
				this.showOptions = true;
				this.itemWasSelected = false;
				this.cancelSubscriptions();
				this.initSubscriptions();
			}, 300)
		}
	}

	resetDropdown() {
		this.firstOpen = true;
		this.showOptions = true;
		this.itemWasSelected = false;
		this.cancelSubscriptions();
		this.initSubscriptions();
	}
  
	search() {
		this.searchvalue = this.inputValue
		let a = this.nameLabel;
		if (this.backTranslate) {
			a = this.nameLabel + '_' + this._gS.getLenguage()
		}
		this.filteredList = this.list;
		this.filteredList = this._SearchPipe.transform(this.filteredList, this.searchvalue, a);

		if (this.toCreate) {
			const nameLabel = this.nameLabel
			const searchValue = this.searchvalue
			const found = this.filteredList.find(element => {
				return element[nameLabel].toLowerCase() == searchValue.toLowerCase();
			});
			if (found) {
				this.createValue = undefined;
			} else {
				this.createValue = this.searchvalue;
				this.appModel = undefined;
				this.appModelChange.emit(this.appModel);
        		this.setValueControl(this.appModel)
			}
			this.createValueChange.emit(this.createValue);
		}
	}
	startDropDown() {
		this.filteredList = this.list;
		this.resetDropdown();
		this.searchvalue = '';
		// this.inputValue = '';

	}
	getName(ev: string) {
		if (this.backTranslate) {
			return ev[this.nameLabel + '_' + this._gS.getLenguage()];
		}
		return ev[this.nameLabel];
	}
	selectOption(ev, isFromBlur = false) {
		if (this.color) {
			this.selected_color = ev;
		}
		if (!this.multiple) {
			this.appModel = this.getValue(ev);
			this.inputValue = this.getName(ev);
			this.appModelChange.emit(this.appModel);
			this.appChange.emit(ev);
      this.setValueControl(this.appModel)

			this.showOptions = false;
			this.wasInside = false;

			this.itemWasSelected = this.wasClickNav && isFromBlur ? false : true;
			this.wasClickNav = false;

			if (this.toCreate) {
				this.createValue = undefined;
				this.createValueChange.emit(this.createValue);
        this.setValueControl(this.appModel)
			}
		} else {
			if (ev.selected) {
				ev.selected = false
			} else {
				ev.selected = true
			}
			if (ev.selected) {
				this.appModel.push(ev);

			} else {
				let i = 0
				for (let sel of this.appModel) {
					if (sel[this.valueId] == ev[this.valueId]) {
						this.appModel.splice(i, 1);
					}
					i++
				}
			}
			this.appModelChange.emit(this.appModel);
      	this.setValueControl(this.appModel)
			this.checkMultipleText();
		}
	}
	checkMultipleText() {
		const a = []
		this.inputValue = ''
		for (let obj of this.appModel) {
			a.push(this.getName(obj));
		}
		this.inputValue = a.join(', ')
	}
	blur() {
		if (!this.multiple) {
			if (!this.toCreate) {
				this.executeBlur();
			} else {
				const nameLabel = this.nameLabel
				const searchValue = this.searchvalue
				const found = this.filteredList.find(element => {
					const c = element[nameLabel];
					if (c) {
						return c.toLowerCase() == searchValue.toLowerCase();
					} else {
						return ''
					}
				});
				if (found) {
					this.createValue = undefined;
					this.selectOption(found, true);
					this.executeBlur()
				}
			}
		}
	}
	executeBlur() {
		setTimeout(() => {
			if (!this.wasClickNav) {
				this.showOptions = false;
				this.cancelSubscriptions();

				if (this.appModel) {
					const valueId = this.valueId
					const appModel = this.appModel
					const found = this.list.find(element => {
						return element[valueId] == appModel;
					});
					this.selectOption(found)
				}
			}
			this.wasClickNav = false;
		}, 300);
	}
	getValue(ev) {
		return ev[this.valueId];
	}
	setChange() {
		if (this.multiple) {
			const a = []
			if (this.appModel) {
				if (this.appModel.length > 0) {
					for (let item of this.list) {
						item.selected = false;
						for (let obj of this.appModel) {
							if (item[this.valueId] == obj[this.valueId]) {
								item.selected = true;
								if (this.showCheckboxOptions) {
									item.isExcluded = obj.isExcluded;
								}
								a.push(item)
							}
						}
					}
				} else {
					for (let item of this.list) {
						item.selected = false;
					}
				}
			}
			this.appModel = a;
			this.appModelChange.emit(this.appModel);
      this.setValueControl(this.appModel)
			this.checkMultipleText();
		} else {
			if (this.appModel) {
				for (let item of this.list) {
					if (this.getValue(item).toString() == this.appModel.toString()) {
						this.selectOption(item)
					}
				}
			}
		}
		this.filteredList = this.list;
	}

	trackBy(index, item) {
		return item[this.valueId];
	}

	toggleWithoutOption(event, option) {
		event.stopPropagation();
		option.isExcluded = !option.isExcluded;
	}

	constructor(
		private _elementRef: ElementRef,
		public _gS: GlobalService,
		private _SearchPipe: SearchPipe,
		private _cD: ChangeDetectorRef) { }

	initSubscriptions() {
		this.subs.push(this.$inputClick.subscribe(data => {
			this.showOptions = !this.itemWasSelected ? true : false;
			this.wasInside = !this.itemWasSelected ? true : false;
			this.itemWasSelected = false;
		}));
		this.subs.push(this.$documentClick.subscribe(data => {
			if (!this.wasInside) {
				this.showOptions = false;
				this.cancelSubscriptions();
				this.onClose.emit();
				this._cD.detectChanges();
			}
			this.wasInside = this.firstOpen && !this.multiple ? true : false;
			this.firstOpen = false;
		}));
	}

	cancelSubscriptions() {
		this.subs.map(s => s.unsubscribe());
	}

	ngOnChanges(changes: SimpleChanges) {
		if (!this.multiple) {
			if (changes.appModel && !changes.firstChange) {
				if (changes.appModel.currentValue != changes.appModel.previousValue) {
					if (changes.appModel.currentValue == undefined || changes.appModel.currentValue == '') {
						this.inputValue = '';
					} else if (changes.appModel.previousValue == '' || changes.appModel.previousValue == undefined || changes.appModel.previousValue) {
						for (let itm of this.list) {
							if (changes.appModel.currentValue == itm[this.valueId]) {
								this.selectOption(itm)
							}
						}
					}
				}
			}
		} else {
			if (changes.appModel && !changes.firstChange) {
				if (changes.appModel.currentValue != changes.appModel.previousValue) {
					if (changes.appModel.currentValue.length == 0) {
						if (this.list) {
							this.inputValue = '';
							for (let item of this.list) {
								item.selected = false;
							}
						}

					} else {
						let isDifferent = _.xorWith(changes.appModel.previousValue, changes.appModel.currentValue, _.isEqual).length > 0;
						if (isDifferent) {
							this.setChange();
						}
					}

				}
			}
		}

		if (changes.list) {
			if (!changes.list.firstChange) {
				this.sliceStart = 0
				this.sliceEnd = this.sliceLength;
				this.filteredList = this.list;
			}
		}
	

	}
	ngOnInit() {
		this.setChange();
	}

	ngAfterViewInit() {
		this.$documentClick = fromEvent(document, 'click');
		this.$inputClick = fromEvent(this.theInput.nativeElement, 'click');
	}

	ngOnDestroy() {
		this.cancelSubscriptions();
	}

  setValueControl(value){
    this.value = value
    this.onChange(value)
  }

  public writeValue(value: any): void {
	  
    this.value = value;
	this.appModel = value
	this.setChange()
  }

 public registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  public registerOnTouched(fn: any): void {
  this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
 }

 
  public validate(c: UntypedFormControl){
    return (this.value) ? null : {
      inputError: {
        valid: false,
      },
    };
  }

}

  

